<template>
  <div>
    <span @click="goToFacebook()" class="chapterName" :class="country ? 'countryName' : ''" :title="chapter.info.facebook_url"> {{chapter.name}} </span>
    <span v-if="twitter()" class="twitterLink" @click="goToTwitter()">
      <FontAwesomeIcon :icon="['fab', 'twitter']" /> {{twitter()}}
    </span>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import { Chapter } from '../store/regions/types'

export default {
  name: 'ChapterDetail',
  components: { FontAwesomeIcon },
  props: ['chapter', 'country'],
  methods: {
    goToFacebook() {
      if (this.chapter.info.facebook_url) {
        window.open(this.chapter.info.facebook_url, '_blank')
      } else if (this.chapter.info.url) {
        window.open(this.chapter.info.url, '_blank')
      }
    },

    goToTwitter() {
      window.open('https://twitter.com/' + this.chapter.info.twitter, '_blank')
    },

    facebookUrl() {
      const info = this.chapter.info
      if (info.facebook_url) {
        return info.facebook_url
      }
      return null
    },

    twitter() {
      return null
      // We don't want to show the twitter pages any more as the linkage doesn't work.
      // const info = this.chapter.info
      // if (info.twitter) {
      //   return info.twitter
      // }
      // return null
    }

  }
}

</script>

<style lang="scss" scoped>
.chapterName {
  font-size: .95em;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.countryName {
  font-size: 1.2em;
}
.twitterLink {
  color:#006dbf;
  margin-left:10px;
  margin-right:-20px;
}
</style>
